import type { FC } from 'react';
import React from 'react';
import type { Theme } from '@material-ui/core/styles';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import {
  Typography, ListItemAvatar, Avatar, ListItemText, MenuItem, Paper, Grid, ListItem,
} from '@material-ui/core';
import clsx from 'clsx';
import TimerIcon from '@material-ui/icons/Timer';

import globalUseStyles from '../../globalClasses';

const useStyles = makeStyles((theme: Theme) => createStyles({
  menuItem: {
    marginBottom: 0,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:focus, &:hover': {
      backgroundColor: '#D6E1EF',
    },
    '.MuiTypography-root': {
      marginBottom: 0,
    },
  },
  primaryText: {
    fontSize: '1rem',
    marginBottom: '.125em',
    fontWeight: 700,
  },
  secondaryText: {
    fontSize: '0.75rem',
    margin: 0,
  },
  paper: {
    marginTop: '0.75rem',
    width: '100%',
  },
  touchDot: {
    color: theme.palette.warning.main,
    fontSize: 10,
  },
  disabled: {
    opacity: '0.4',
    filter: 'alpha(opacity=40)',
  },
}));

interface MessageProps {
  primaryText: string,
  secondaryText: string,
  icon: React.ReactElement,
  iconColor: 'green' | 'blue' | 'red',
  onClickFunction: () => void
  disabled?: boolean,
  timer?: string,
}

const MessageItem: FC<MessageProps> = ({
  primaryText, secondaryText, onClickFunction, icon, iconColor, disabled = false, timer,
}) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const iconColorClass = () => {
    if (iconColor === 'green') {
      return globalStyles.greenIcon;
    }
    if (iconColor === 'blue') {
      return globalStyles.blueIcon;
    }
    return globalStyles.redIcon;
  };

  return (
    <Paper className={classes.paper}>
      <MenuItem onClick={onClickFunction} className={clsx(classes.menuItem, disabled ? classes.disabled : null)} dense>
        <Grid
          container
          spacing={0}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={4}>
            <ListItem dense disableGutters>
              <ListItemAvatar style={{ minWidth: '1rem', paddingRight: '0.5rem' }}>
                <Avatar className={clsx(globalStyles.smallAvatar, iconColorClass())}>
                  {icon}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={<Typography variant="h6" color="primary" className={classes.primaryText}>{primaryText}</Typography>}
                secondary={secondaryText}
                classes={{
                  primary: classes.primaryText,
                  secondary: classes.secondaryText,
                }}
              />
            </ListItem>
          </Grid>
          {
            timer && (
              <Grid item xs={4}>
                <ListItem dense disableGutters>
                  <ListItemAvatar style={{ minWidth: '1.75rem', paddingLeft: '0.75rem' }}>
                    <Avatar className={clsx(globalStyles.smallAvatar)}>
                      <TimerIcon className={globalStyles.smallIconSize} />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    secondary={timer}
                    classes={{
                      secondary: classes.secondaryText,
                    }}
                  />
                </ListItem>
              </Grid>
            )
          }
        </Grid>
      </MenuItem>
    </Paper>
  );
};
export default MessageItem;
